export default {
  '主頁': 'หน้าหลัก',
  '一般查證': 'เช็กเลขพาสปอร์ต',
  '大量查證': 'เช็กเลขพาสฯทีละมาก',
  '上傳檔案': 'อัพโหลดไฟล์',
  '下載查證結果': 'โหลดผลการเช็ค',
  '下載格式': 'โหลดตาราง',
  '大量查證失敗!請確認上傳格式是否正確，或聯絡開通中心 0800-222-179 ，謝謝': 'เช็คเลขพาสปอร์ตล้มเหลว ตรวจเช็ครูปแบบการอัปโหลดถูกต้องหรือไม่ หรือติดต่อเบอร์ 02-82273308 ต่อสาย 20 หรือ 21',
  '補卡查證': 'ซิมใหม่เบอร์เดิม',
  '升級查證': 'อัพเกรดซิม',
  '門號查詢': 'เช็คหมายเลข',
  '查證紀錄': 'ประวัติการเช็ค',
  '問題紀錄': 'ประวัติซิมที่มีปัญหา',
  '登出': 'ออกจากระบบ',
  '快速功能': 'ฟังก์ชั่น',
  '快速搜尋': 'ค้นหา',
  '近期記錄': 'บันทึกล่าสุด',
  '日期': 'วันที่',
  '證號': 'เลขพาสปอร์ต',
  '結果': 'ผลการเช็ค',
  '備註': 'หมายเหตุ',
  '當查證結果等待超過5分鐘時，請聯絡開通中心 02-8227-3308分機20及21，謝謝': 'หากรอผลเช็คเกิน 5 นาที ติดต่อเบอร์02-82273308 ต่อสาย 20 หรือ 21 หรือแอดไลน์ ID : sofa0800222179',
  '已辦過': 'เคยเปิด',
  '已辦門號': 'เคยเปิด',
  '欠費': 'ค้างชำระเงิน',
  '風險': 'ติดแบล็คลิส',
  '有人查過': 'เคยเช็ค',
  '護照號碼': 'พาสปอร์ต',
  '目前身份': 'รหัสผู้เข้าใช้งาน',
  '門號': 'หมายเลขโทรศัพท์',
  '身分證字號': 'บัตรประชาชน',
  '身分證驗證': 'เช็คข้อมูลบัตรไต้หวัน',
  '請選擇證件類別': 'เลือกเอกสาร',
  '請輸入證號': 'ใส่เลขพาสปอร์ต ',
  '居留證查詢': 'เช็คบัตรต่างด้าว',
  '請輸入生日': 'ใส่วันเกิด',
  '生日 為必填': 'ระบุวันเกิด',
  '國籍 為必填': 'ระบุสัญชาติ',
  '生日': 'วันเกิด',
  '國籍': 'สัญชาติ',
  '泰國': 'ไทย',
  '印尼': 'อินโดนีเซีย',
  '越南': 'เวียดนาม',
  '菲律賓': 'ฟิลิปินส์',
  '印度': 'อินเดีย',
  '其他': 'อื่นๆ',
  '中國': 'จีน',
  '確定': 'ยืนยัน',
  '確定送出': 'ยืนยันส่ง',
  '查證系統': 'ระบบตรวจเช็ค',
  '請先登入系統': 'ให้เข้าระบบก่อน',
  '手機號碼': 'ใส่หมายเลขโทรศัพท์',
  '取得簡訊驗證碼': 'รับรหัสยืนยัน',
  '認證碼': 'รหัสยืนยัน',
  '重新發送驗證碼': 'ส่งรหัสยืนยันใหม่',
  '登入系統': 'เข้าสู่ระบบ',
  '驗證碼錯誤': 'รหัสยืนยันไม่ถูกต้อง',
  '系統目前無法登入，請聯絡開通中心 02-8227-3308分機20及21。': 'เข้าระบบไม่ได้ ติดต่อเบอร์ 02-82273308 ต่อสาย 20 หรือ 21หรือแอดไลน์ ID : sofa0800222179',
  '此電話號碼不存在': 'ไม่มีหมายเลขนี้ในระบบ',
  '無法取的認證碼，請聯絡開通中心 02-8227-3308分機20及21。': 'ไม่ได้รับรหัสยืนยัน  ติดต่อเบอร์ 02-82273308 ต่อสาย 20 หรือ 21',
  '問題件': 'เอกสารมีปัญหา',
  '辦門號': 'เปิดซิม',
  '系統編號': 'เลขระบบ',
  '門號類型': 'ประเภท',
  '辦門號記錄': 'ประวัติที่เปิดซิม',
  '狀態': 'สถานะ',
  '一般門號': 'เปิดซิมใหม่',
  '升級': 'อัพเกรดซิม',
  '換補卡': 'ซิมใหม่เบอร์เดิม',
  '卡號': 'เลขซีเรียล',
  '此卡不在庫存內，請聯絡相關人員。': 'ซิมนี้ไม่ใช่ของคุณ ติดต่อคนที่ให้ซิม',
  '聯絡電話': 'เบอร์โทรติดต่อ',
  '預計開通日': 'วันที่เปิดใช้งาน',
  '仲介名': 'ชื่อเอเย่นส์',
  '認證電話': 'หมายเลขที่ใช้เข้าระบบ',
  '看申請書': 'ดูใบสมัครเปิดซิม',
  '中華申請書': 'สัญญาใบสมัครเปิดซิมจงหัว',
  '請用正楷簽名': 'เขียนชื่อ ตัวบรรจง',
  '確認簽名': 'ยืนยันลงชื่อ',
  '請閱讀申請書並簽名': 'อ่านใบสมัคร/ลงชื่อ',
  '請將 QRCODE 對準掃瞄框': 'สแกนคิวอาร์โค้ด',
  '掃描錯誤，內容如下:': 'สแกนไม่ผ่าน',
  '您必須打開鏡頭權限': 'กดอนุญาตเปิดกล้อง',
  '找不到相機': 'ไม่พบกล้อง',
  '相機已經被其他程式佔用': 'กล้องคุณใช้งานโปรแกรมอื่น',
  '系統無法支援此瀏覽器': 'ระบบไม่รองรับเบราว์เซอร์นี้',
  '重新掃描': 'สแกนใหม่',
  '清除': 'ลบ',
  '取消': 'ยกเลิก',
  '我已閱讀{term}並同意加入九亨會員': "ข้าพเจ้า{term}และยอมรับเป็นสมาชิกบริษัทBest We Serve Int'l Co. Ltd",
  '閱讀條款': 'ได้อ่านข้อตกลง',
  '請檢查所有欄位是否填寫正確': 'โปรดตรวจสอบข้อมูลที่ให้ว่าครบและถูกต้องหรือไม่',
  '送件': 'ส่ง',
  '暫存': 'บันทึกชั่วคราว',
  '關閉': 'ปิด',
  '刪除': 'ลบ',
  '上傳中': 'กำลังอัปโหลด',
  '讀取中': 'กำลังอัปโหลด',
  '送件完成': 'ส่งเอกสารสำเร็จ',
  '暫存成功': 'บันทึกสำเร็จ',
  '抱歉！找不到此暫存件！': 'ขออภัย ไม่พบการบันทึกชั่วคราว',
  '確定刪除照片嗎？': 'ยืนยันที่จะลบรูป?',
  '確定要刪除此筆？所有的資料都會消失，此動作不可復原？': 'แน่ใจลบข้อมูลนี้?ข้อมูลทั้งหมดจะถูกลบและกู้คืนไม่ได้',
  '刪除成功': 'ลบสำเร็จ',
  '抱歉！無法暫存，請稍後再試！': 'ขออภัย บันทึกข้อมูลไม่ได้ โปรดลองใหม่อีกครั้ง',
  '全部': 'ทั้งหมด',
  '抱歉！刪除失敗，請稍後再試！': 'ลบยังไม่ได้ ลองใหม่ภายหลัง',
  '未進件': 'เอกสารที่ยังไม่ได้ส่ง',
  '已送件': 'ส่งเอกสารแล้ว',
  '預計開通': 'ระบุวันเปิดใช้งาน',
  '已開通': 'เปิดซิมสำเร็จ',
  '已退卡': 'คืนซิมสำเร็จ',
  '已停話': '已停話',
  '照片張數 不得小於{0}': 'จำนวนรูปต้องไม่น้อยกว่า {0} รูป',
  '門號 為必填': 'ต้องใส่เบอร์ซิม',
  '卡號 為必填': 'ต้องใส่เลขซีเรียลซิม ',
  '門號不完整': 'ใส่เบอร์โทรศัพท์ไม่ครบ',
  '抱歉! 無法暫存，請稍後再試!': 'ขออภัย เซฟข้อมูลชั่วคราวไม่ได้ ลองใหม่ภายหลัง',
  '照片數不能超過 7 張': 'ส่งรูปได้ไม่เกิน 7 รูป',
  '回辦門號紀錄': 'กลับไปที่บันทึกเปิดซิม',
  '繼續辦門號': ' เปิดซิมต่อ',
  '回主畫面': 'กลับหน้าหลัก',
  '查證': 'เช็กเอกสาร',
  '我己閱讀並了解': 'ข้าพเจ้าได้อ่านข้อตกลงและเข้าใจแล้ว',
  '如特定開通日期，才需點選': 'ถ้าต้องการระบุวันเปิดใช้งาน กด',

  // 大量查證
  '班機': 'ใส่เที่ยวบิน',
  '班機狀態': 'สถานะเที่ยวบิน',
  '未知': 'วันนี้ไม่มีเที่ยวบินนี้',
  '準時': 'ตรงเวลา',
  '取消': 'ยกเลิก',
  '延誤': 'เที่ยวบินล่าช้า',
  '時間變更': 'เปลี่ยนเวลา',
  '抵達': 'ถึงไต้หวันแล้ว',
  '表定抵達時間': 'เวลาเดินทาง',
  '班機為必填': 'ต้องใส่เที่ยวบิน',
  '落地日期': 'วันที่ถึงไต้หวัน',
  '落地日期及時間 為必填': 'โปรดระบุวันที่และเวลาถึงไต้หวัน',
  '拍正反面：居留證、身份證、學生證、駕照': 'ถ่ายด้านหน้าและด้านหลัง  : 1. บัตรกาม่าหรือพาสปอร์ต  2. บัตรสุขภาพ หรือวีซ่า (VISA) พร้อมประทับตราเข้าประเทศหรือใบขับขี่ไต้หวัน',
  '護照、簽證(VISA)、勞動契約及全身照': 'พาสปอร์ต วีซ่า (VISA) หนังสือสัญญาจ้างงาน และรูปถ่ายเต็มตัว',
  '看申請書並正楷簽名': 'อ่านใบสมัคร/ลงชื่อ',
  '重簽名': 'ลงชื่อใหม่',
  '上傳照片': 'อัปโหลดรูป',
  '增加照片': 'เพิ่มรูป',
  '3張以上,最多7張': 'อัปรูปขั้นต่ำ3รูปสูงสุดไม่เกิน7รูป',
  '大量辦門號': 'เปิดซิมจำนวนมาก',
  '選取照片': 'เลือกรูป',
  '點擊上傳或是拖曳照片到畫面中': 'คลิกอัปรูปหรือลากรูปไปที่หน้าจอ',
  '目前總共選取了{0}張照片': 'ตอนนี้เลือกรูปแล้วจำนวน {0} รูป',
  '重新選擇': 'เลือกใหม่',
  '上傳照片': 'อัปโหลดรูป',
  '為了上傳更有效率，建議請將圖檔尺寸在 1200x1200 內。': 'เพื่อให้อัปรูปได้รวดเร็ว ให้ใช้ไฟล์ขนาดไม่เกิน 1200x1200',
  '檔名': 'ชื่อไฟล์',
  '檔案大小': 'ขนาดไฟล์',
  '下一步': 'ต่อไป',
  '上傳失敗！請確認一下網路狀態，或是稍後再試。\n若持續有問題，請聯絡系統管理員。(請聯絡開通中心02-8227-3308分機20及21，謝謝)': 'อัปโหลดล้มเหลว เช็กสัญญานเน็ต หรือลองใหม่อีกครั้ง \nหากยังมีปัญหาติดต่อเบอร์ 02-82273308 ต่อสาย 20 หรือ 21',
  '大量辦門號成功!': 'เปิดซิมจำนวนมากสำเร็จ!',
  '辦門號紀錄上傳中，請勿關閉視窗。': 'กำลังอัปโหลด โปรดอย่าปิดหน้าต่างนี้',
  'SIM卡庫存': 'สต๊อกซิม',
  '庫存': 'สต๊อก',
  '類型': 'ประเภท',
  '動作': 'เลือก',
  '照片數': 'จำนวนรูป',
  '上傳狀態': 'สถานะอัปโหลด',
  '上一步': 'ก่อนหน้า',
  '目前比對出{0}筆可送件辦門號, 請確認': 'ระบบตรวจเช็ค, เช็คแล้วมีที่ส่งได้มีจำนวน {0} เบอร์ ระบบจะตรวจสอบ กรณีเข้าข่ายในเงื่อนไขนี้',
  '暫存門號需有簽名才能比對': 'บันทึกชั่วคราวต้องมีการลงชื่อถึงจะเช็กได้',
  '單一門號照片數量,3張以上最多的7張': 'ซิมแต่ละซิมต้องมีรูปขั้นต่ำ 3รูปสูงสุดไม่เกิน7รูป',
  '照片檔要符合檔名規則09XXXXXXXX': 'ชื่อไฟล์ต้องเป็นเบอร์ 09XXXXXXXX',
  'API呼叫失敗': 'API ล้มเหลว',

  // 問題件說明
  '問題件類型': 'ประเภทของปัญหา',
  '問題件說明': 'คำอธิบายปัญหา',
  '證件': 'เอกสาร',
  '欠費-本期.呆帳.拆機': 'ค้างจ่าย รอบนี้ หนี้เสีย ปลดสาย',
  '簽名': 'ลงชื่อ',
  '未開通卡片遺失': 'ซิมหาย ยังไม่ได้เปิดใช้งาน',
  '台灣人': 'คนไต้หวัน',
  '未滿18歲': 'อายุไม่ครบ18ปี',
  '日期輸入不正確': 'วันที่ไม่ถูกต้อง',
  '流程重做': 'เริ่มทำขั้นตอนอีกครั้ง',
  '升級.補卡資料不符': 'อัปซิม เปลี่ยนซิม เอกสารไม่ตรง ',
  '非本人': 'ไม่ใช่เจ้าตัว',
  '人像照': 'ถือเอกสารรูปถ่ายครึ่งตัว',
  '補件': 'เพิ่มเอกสาร',
  '其他': 'อื่นๆ',
  '[201]': 'ข้อมูลไม่ถูกต้อง โปรดลองอีกครั้ง',
  '[OR1102]': 'ข้อมูลไม่ถูกต้อง โปรดลองอีกครั้ง',
  '[OR4212]': 'เคยเปิดแล้ว',
  '[OR421A]': 'ไม่สารมารถเปิดบริการทันทีหรือบริการไม่ได้',
  '[OR421B]': 'ข้อมูลไม่ถูกต้อง โปรดลองอีกครั้ง',
  '[OR421C]': 'ไม่สารมารถเปิดบริการทันทีหรือบริการไม่ได้',
  '[OR5101]': 'ข้อมูลไม่ถูกต้อง โปรดลองอีกครั้ง',
  '[OR5101]': 'ข้อมูลไม่ถูกต้อง โปรดลองอีกครั้ง',
  '[OR4210]': 'ข้อมูลไม่ถูกต้อง โปรดลองอีกครั้ง',
  '[OR4211]': '',
  '[OR4213]': '',
  '[OR4214]': '',
}
